import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function CopyIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.3556,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
  };
  const st1: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 0.9425,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g>
        <polygon
          style={st0}
          points="19.68,8.91 19.68,13.69 19.68,18.47 19.68,23.25 15.77,23.25 11.86,23.25 7.96,23.25 4.05,23.25 
                4.05,18.47 4.05,13.69 4.05,8.91 4.05,4.13 7.96,4.13 11.86,4.13 15.77,4.13 	"
        />
        <polygon style={st1} points="15.77,4.13 15.77,9.14 19.68,9.14 	" />
        <polyline
          style={st0}
          points="0.76,19.58 0.76,10.17 0.76,0.75 7.21,0.75 13.65,0.75 	"
        />
      </g>
    </SvgIcon>
  );
}
